import { WHATSAPP_NUMBER } from 'shared/constants'
import { openExternalUrl } from 'shared/lib/external-open'

export const openWhatsappWithMessage = (message: string) => {
  openExternalUrl(
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`,
  )
}
